
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as XLSX from 'xlsx';

@Component
export default class ExcelImporter extends Vue {

  fileName: string = '';

  onFileInput() {
    (this.$refs.fileInput as any).click();
  }

  readFile(event: any) {
    this.fileName = '';
    const file = event.target.files[0];
    if (!file) {
      this.clearFile();
      return;
    }
    this.fileName = file.name;
    const reader = new FileReader();
    reader.onload = e => {
      if (e.target && e.target.result) {
        const data = new Uint8Array(e.target.result as any);
        const workbook = XLSX.read(data, { type: 'array', dateNF: 'yyyy-mm-dd' });
        this.$emit('upload', workbook);
      }
    };
    reader.readAsArrayBuffer(file);
  }

  clearFile() {
    (this.$refs.fileInput as any).value = null;
    this.fileName = '';
    this.$emit('clear');
  }
  
}
